const MIN_DIFFERENCE = 100;

type IRGBColor = { r: number; g: number; b: number };

const generateRandomColor = () => ({
  r: Math.floor(Math.random() * 256),
  g: Math.floor(Math.random() * 256),
  b: Math.floor(Math.random() * 256),
});

const colorDifference = (color1: IRGBColor, color2: IRGBColor) =>
  Math.abs(color1.r - color2.r) + Math.abs(color1.g - color2.g) + Math.abs(color1.b - color2.b);

const isColorUnique = (newColor: IRGBColor, existingColor: IRGBColor, minDifference: number) =>
  colorDifference(newColor, existingColor) > minDifference;

export const getRandomColors = (length: number): string[] => {
  const colors: IRGBColor[] = [];

  for (let i = 0; i < length; i++) {
    let newColor = generateRandomColor();

    if (i === 0) {
      colors.push(newColor);
    } else {
      let count = 0;

      while (count < 1000 && !isColorUnique(newColor, colors[i - 1], MIN_DIFFERENCE)) {
        newColor = generateRandomColor();
        count++;
      }
      colors.push(newColor);
    }
  }

  return colors.map(({ r, g, b }) => `rgb(${r}, ${g}, ${b})`);
};
